import React, { useEffect, useState } from "react";
import blogData from "../../Data/blogData";
import { Link } from "react-router-dom";

// BlogPage Component
const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    setBlogs(blogData);
  }, []);

  return (
    <section className="th-blog-wrapper space-top space-extra2-bottom">
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title6 justify-content-center">
            <span className="shape left">
              <span className="dots"></span>
            </span>
            OUR Blogs
            <span className="shape right">
              <span className="dots"></span>
            </span>
          </span>
          <h2 className="sec-title">Explore News & Feed</h2>
        </div>

        <div className="row gx-40">
          {/* Mapping through the blogPosts array */}
          {blogs.map((post, index) => (
            <div key={post.id} className="col-md-6">
              <div className="th-blog blog-single has-post-thumbnail">
                <div className="blog-img">
                  {/* Display only images */}
                  <Link to="">
                    <img src={post.image} alt="Blog Imagee" />
                  </Link>
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <Link className="author" to="">
                      <i className="fa-solid fa-user"></i>
                      {post.author}
                    </Link>
                    <Link to="">
                      <i className="fa-solid fa-calendar-days"></i>
                      {post.date}
                    </Link>
                  </div>
                  <h2 className="blog-title">
                    <Link to={`/blog/blog-details/${post.id}`}>
                      {post.title}
                    </Link>
                  </h2>
                  <p className="blog-text">
                    {post.description.slice(0, 100)}...
                  </p>
                  <Link to={`/blog/blog-details/${post.id}`} className="th-btn">
                    Read More <i className="fas fa-arrow-right ms-2"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPage;
